var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sop-container" },
    [
      _c("MySearch", {
        attrs: { namePlaceholder: _vm.namePlaceholder, KHSOPxbc: _vm.KHSOPxbc },
        on: {
          searchFn: _vm.searchFn,
          selectTime: _vm.selectTime,
          createSOP: _vm.createSOP
        }
      }),
      _c("tableWrap", {
        scopedSlots: _vm._u([
          {
            key: "table",
            fn: function() {
              return [
                _c(
                  "el-table",
                  {
                    ref: "returnVisitSOPTable",
                    staticStyle: { width: "100%", "font-size": "13px" },
                    attrs: {
                      size: "medium",
                      "header-cell-style": {
                        background: "#eef1f6",
                        color: "#606266"
                      },
                      height:
                        _vm.namePlaceholder == "搜索SOP任务名称"
                          ? "calc(100vh - 289px)"
                          : "calc(100vh - 233px)",
                      "highlight-current-row": true,
                      data: _vm.tableData
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "序号",
                        type: "index",
                        width: "50",
                        align: "center"
                      }
                    }),
                    _vm._l(_vm.tableHeader, function(item, index) {
                      return _c("el-table-column", {
                        key: item.id,
                        attrs: {
                          label: item.label,
                          prop: item.id,
                          "show-overflow-tooltip": "",
                          "min-width": item.minWidth,
                          align: item.align
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function(scope) {
                                return [
                                  _vm._v(" " + _vm._s(item.label) + " "),
                                  item.id == "empNum"
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "群发应完成的员工人数，指的是有可触达的客户的员工，可能与选择员工数不一致，因为部分所选员工没有可触达的客户",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-question"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.namePlaceholder == "搜索SOP任务名称"
                                    ? _c("div", [
                                        item.id != "createMessage" &&
                                        item.id != "option"
                                          ? _c(
                                              "div",
                                              {
                                                class:
                                                  item.id == "content"
                                                    ? "content-col"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.row[item.id]) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        item.id == "createMessage"
                                          ? _c("div", [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.createByName +
                                                        " | " +
                                                        _vm.getTime(
                                                          scope.row.createTime
                                                        )
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ])
                                          : _vm._e(),
                                        item.id == "option"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "table-button",
                                                    attrs: {
                                                      type: "text",
                                                      size: "small"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.handleDetail(
                                                          scope.row.sopId,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("详情")]
                                                ),
                                                _vm.KHSOPcd
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "table-button",
                                                        attrs: {
                                                          type: "text",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.handleData(
                                                              scope.row.sopId,
                                                              scope.row.sopName,
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("数据")]
                                                    )
                                                  : _vm._e(),
                                                _vm.KHSOPxbc &&
                                                _vm.namePlaceholder ==
                                                  "搜索SOP任务名称"
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "table-button",
                                                        attrs: {
                                                          type: "text",
                                                          size: "small"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.handleDel(
                                                              scope.row.sopId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("删除")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ])
                                    : _c("div", [
                                        item.id == "msgName"
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center"
                                                }
                                              },
                                              [
                                                scope.row.caller == 1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#FFF",
                                                          "background-color":
                                                            "#409EFF",
                                                          "font-size": "12px",
                                                          padding: "2px 5px",
                                                          "border-radius":
                                                            "4px",
                                                          "margin-right": "2px"
                                                        }
                                                      },
                                                      [_vm._v("院内")]
                                                    )
                                                  : _vm._e(),
                                                scope.row.status == -1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#F56C6C"
                                                        }
                                                      },
                                                      [_vm._v("【处理失败】")]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "ellipsis-one"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row[item.id]
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : item.id == "resourceList"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image-container"
                                              },
                                              [
                                                scope.row.resourceList &&
                                                scope.row.resourceList.length >
                                                  0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "image-main"
                                                      },
                                                      _vm._l(
                                                        scope.row.resourceList,
                                                        function(item, index) {
                                                          return _c(
                                                            "el-image",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "item-image",
                                                              attrs: {
                                                                src:
                                                                  item.fileFullUrl,
                                                                fit: "contain"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.previewTableImage(
                                                                    item.fileFullUrl
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "image-slot",
                                                                  attrs: {
                                                                    slot:
                                                                      "error"
                                                                  },
                                                                  slot: "error"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "10px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "加载失败"
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : item.id == "empNumDone" ||
                                            item.id == "empNumNoDone"
                                          ? _c("div", [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.status == 0
                                                        ? scope.row[item.id]
                                                        : "-"
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ])
                                          : item.id == "createMessage"
                                          ? _c("div", [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.createByName +
                                                        " | " +
                                                        _vm.getTime(
                                                          scope.row.createTime
                                                        )
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ])
                                          : item.id == "option"
                                          ? _c("div", [
                                              scope.row.status == -1
                                                ? _c("div", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ellipsis-one"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "数据处理失败，请重新创建该群发"
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "table-button",
                                                          attrs: {
                                                            type: "text",
                                                            size: "small"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.handleDetail(
                                                                scope.row.sopId,
                                                                scope.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("详情")]
                                                      ),
                                                      _vm.KHSOPcd
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              staticClass:
                                                                "table-button",
                                                              attrs: {
                                                                type: "text",
                                                                size: "small"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.handleData(
                                                                    scope.row
                                                                      .sopId,
                                                                    scope.row
                                                                      .sopName,
                                                                    scope.row
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("数据")]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                            ])
                                          : _c(
                                              "div",
                                              {
                                                class:
                                                  item.id == "content"
                                                    ? "content-col"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.row[item.id]) +
                                                    " "
                                                )
                                              ]
                                            )
                                      ])
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    })
                  ],
                  2
                )
              ]
            },
            proxy: true
          },
          {
            key: "pagination",
            fn: function() {
              return [
                _c("Pagination", {
                  attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
                  on: { callBack: _vm.callBack }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("el-image", {
        ref: "myImg",
        staticClass: "my-preview-image-j",
        attrs: { src: _vm.previewUrl, "preview-src-list": _vm.previewSrcList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }